import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch';
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel';
import { toggleEnabledWithEntity, openPaywall } from '../Redux/Actions';
import { getAppEnabled, getCanUseApp } from '../../../../Resources/Organization/Apps/AppsData';
import { WEBHOOKS } from '../AppsData';

const WebhooksButton = () => {
  const appEnabled = useSelector(getAppEnabled(WEBHOOKS));
  const canUseApp = useSelector(getCanUseApp(WEBHOOKS));
  const dispatch = useDispatch();

  const onSwitchChange = () => {
    dispatch(toggleEnabledWithEntity(WEBHOOKS));
  };

  if (!canUseApp) {
    return (
      <Button
        variant="contained"
        color="primary"
        onClick={() => dispatch(openPaywall())}
      >
        Upgrade
      </Button>
    );
  }
  return (
    <Grid container>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Switch checked={appEnabled} onChange={onSwitchChange} />}
          label={appEnabled ? 'Active' : 'Disabled'}
        />
      </Grid>
    </Grid>
  );
};

export default WebhooksButton;
